import React from 'react'
import { ScrollView } from 'react-native-gesture-handler';
import { SHr, SLoad, SNavigation, SPage, SText, STheme, SView } from 'servisofts-component2'
import Container from '../../Components/Container';
import Verified_icon from '../../Assets/verified_icon.svg';
import MDL from '../../MDL';

export default class ChecklistVehiculos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            vehiculos: [],
            sdni: '',
        };
    }

    async componentDidMount() {
        const sdni = String(SNavigation.getParam('sdni', '') || '').trim();
        this.setState({ sdni });
        await this.loadVehiculos();
    }

    loadVehiculos = async () => {
        this.setState({ loading: true, error: null });
        try {
            const vehiculos = await MDL.checklist.getChecklistVehiculos();
            const rows = (Array.isArray(vehiculos) ? vehiculos : [])
                .map((item) => ({
                    id: item?.lVehiculo_id,
                    tipoVehiculoId: item?.lTipoVehiculo_id ?? item?.tipo_vehiculo_id,
                    matricula: String(item?.sMatricula ?? ''),
                    modelo: String(item?.sModelo ?? ''),
                }))
                .sort((a, b) => a.matricula.localeCompare(b.matricula, 'es', { sensitivity: 'base' }));
            this.setState({
                vehiculos: rows,
                loading: false,
                error: null,
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error?.message || String(error),
                vehiculos: [],
            });
        }
    }

    renderItem(item, index) {
        const hasModelo = !!String(item?.modelo || '').trim();
        const { sdni } = this.state;
        return (
            <SView
                key={String(item?.id ?? index)}
                col={"xs-12"}
                onPress={() => {
                    SNavigation.navigate('/check/ChecklistAssignedTrailer', {
                        sdni,
                        tipo_vehiculo_id: item?.tipoVehiculoId,
                        smatricula: item.matricula || '',
                    });
                }}
                style={{
                    borderRadius: 10,
                    borderWidth: 1,
                    borderColor: STheme.color.lightGray,
                    padding: 12,
                    backgroundColor: STheme.color.primary,
                }}
            >
                <SText font='AlbertSans' bold fontSize={13} color={STheme.color.text}> lVehiculo_id: {String(item?.id ?? '-')} </SText>
                <SHr height={3} />
                <SText font='AlbertSans' fontSize={12} color={STheme.color.text}> lTipoVehiculo_id: {String(item?.tipoVehiculoId ?? '(vacio)')} </SText>
                <SHr height={3} />
                <SText font='AlbertSans' fontSize={12} color={STheme.color.text}> sMatricula: {item.matricula || '(vacio)'} </SText>
                <SHr height={3} />
                <SText font='AlbertSans' fontSize={12} color={hasModelo ? STheme.color.text : STheme.color.danger}> sModelo: {item.modelo || '(vacio)'} </SText>
            </SView>
        );
    }

    render() {
        const { loading, error, vehiculos, sdni } = this.state;
        return (
            <SPage center disableScroll>
                <Container flex>
                    <SView col={"xs-12"} flex style={{ backgroundColor: STheme.color.card, padding: 24, borderRadius: 16 }}>
                        <SView col={"xs-12"} center>
                            <SView col={"xs-12"} center style={{ alignItems: 'center' }} row>
                                <Verified_icon width={18} height={18} fill={STheme.color.secondary} style={{ marginRight: 8 }} />
                                <SText font='AlbertSans' center fontSize={24} color={STheme.color.secondary}>VEHICULOS ACTIVOS</SText>
                            </SView>
                            <SHr height={10} />
                            <SView col={"xs-12"} height={1} style={{ backgroundColor: STheme.color.lightGray }} />
                            <SHr height={10} />
                            <SText font='AlbertSans' center fontSize={14} color={STheme.color.text}>Lista obtenida desde checklist_vehiculos</SText>
                            <SHr height={4} />
                            <SText font='AlbertSans' center fontSize={12} color={STheme.color.secondary}>sdni recibido: {sdni || '(vacio)'}</SText>
                            <SHr height={10} />
                        </SView>
                        <SView col={"xs-12"} flex style={{ minHeight: 0 }}>
                            <ScrollView
                                style={{ flex: 1, width: '100%' }}
                                contentContainerStyle={{ paddingBottom: 12 }}
                                keyboardShouldPersistTaps="handled"
                                showsVerticalScrollIndicator
                            >
                                {loading ? (
                                    <SView col={"xs-12"} center style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <SLoad />
                                        <SHr height={10} />
                                        <SText center color={STheme.color.text}>Cargando vehiculos...</SText>
                                    </SView>
                                ) : null}
                                {error ? (
                                    <SView col={"xs-12"}>
                                        <SText center color={STheme.color.danger}>{error}</SText>
                                    </SView>
                                ) : null}
                                {!loading && !error && vehiculos.length <= 0 ? (
                                    <SView col={"xs-12"}>
                                        <SText center>No hay vehiculos activos.</SText>
                                    </SView>
                                ) : null}
                                {!loading && !error ? vehiculos.map((item, index) => (
                                    <SView key={String(item?.id ?? index)} col={"xs-12"}>
                                        {this.renderItem(item, index)}
                                        <SHr height={8} />
                                    </SView>
                                )) : null}
                            </ScrollView>
                        </SView>
                    </SView>
                </Container>
                <SHr height={20} />
            </SPage>
        );
    }
}